"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Bug_1 = require("../Bug");
var Bootstrap_1 = require("../Bootstrap");
var Helpers_1 = require("../Helpers");
var BugDispatcher = /** @class */ (function () {
    function BugDispatcher(bootstrap, options) {
        if (bootstrap === void 0) { bootstrap = Bootstrap_1.default.getInstance(); }
        this.pointBase = 10;
        this.$bugs = [];
        this.$styleNode = null;
        this.$options = __assign(__assign({}, this.$options), options);
        this.$boostrap = bootstrap;
        this.initialize();
    }
    BugDispatcher.prototype.initialize = function () {
        this.createCssAnimations((0, Helpers_1.generateId)());
        var _a = this.$options, minBugs = _a.minBugs, maxBugs = _a.maxBugs, minDelay = _a.minDelay, maxDelay = _a.maxDelay;
        var bugsCount = (0, Helpers_1.getRandomInRange)(minBugs, maxBugs);
        var bugs = [];
        for (var i = 1; i <= bugsCount; i++) {
            bugs.push(new Bug_1.default(this.$boostrap, this.$options));
        }
        bugs.forEach(function (bug) {
            var db = (0, Helpers_1.debounce)(function () { return bug.walkIn(); }, (0, Helpers_1.getRandomInRange)(minDelay, maxDelay));
            db();
        });
        this.$bugs = bugs;
    };
    BugDispatcher.prototype.removeAll = function () {
        var _this = this;
        var removeDebounce = (0, Helpers_1.debounce)(function () {
            window.document.head.removeChild(_this.$styleNode);
        }, 3000);
        removeDebounce();
    };
    BugDispatcher.prototype.createCssAnimations = function (bugTypeId) {
        var _this = this;
        var animationStyles = "";
        var animationClases = {
            default: "",
            walk: "",
            die: "",
            stop: "",
        };
        animationClases.default = "bug-".concat(bugTypeId);
        animationStyles += "\n    .".concat(animationClases.default, " {\n      cursor: pointer;\n      width: ").concat(this.$options.frameWidth, "px;\n      height: ").concat(this.$options.frameHeight, "px;\n      background-image: ").concat(this.$options.imageSprite, ";\n      position: fixed;\n      z-index: 99999;\n      opacity: 0;\n    }\n    ");
        Object.entries(this.$options.spriteSheetframes)
            .forEach(function (_a) {
            var className = _a[0], xyPosition = _a[1];
            var columns = xyPosition.columns, row = xyPosition.row;
            // 3    -1  *   32; = 128
            var h = (row - 1) * (_this.$options.frameHeight * 2);
            var w = _this.$options.frameWidth;
            var toPosition = columns * w;
            animationClases[className] = "bug-".concat(bugTypeId, "-").concat(className);
            animationStyles += "\n        .".concat(animationClases[className], " {\n          animation: anim-").concat(animationClases[className], " .4s steps(").concat(columns, ") ").concat((className !== "die") ? "infinite" : "forwards", ";\n          background-position: 0px ").concat(h, "px;\n          opacity: 1;\n        }\n        \n        @keyframes anim-").concat(animationClases[className], " {\n          to {\n            background-position: -").concat(toPosition, "px ").concat(h, "px;\n            opacity: ").concat((className === "die") ? "0" : "1", ";\n            display: ").concat((className === "die") ? "none" : "block", ";\n          }\n        }\n        ");
        });
        var styleNode = window.document.createElement("style");
        styleNode.textContent = animationStyles;
        window.document.head.appendChild(styleNode);
        this.$styleNode = styleNode;
        this.$options.classNames = animationClases;
    };
    return BugDispatcher;
}());
exports.default = BugDispatcher;
